{
  "name": "@dinoreic/fez",
  "version": "3.9.7",
  "description": "Runtime custom DOM elements lib",
  "main": "dist/fez.cjs",
  "module": "dist/fez.esm.js",
  "browser": "dist/fez.esm.js",
  "unpkg": "dist/fez.min.js",
  "jsdelivr": "dist/fez.min.js",
  "type": "module",
  "types": "fez.d.ts",
  "exports": {
    ".": {
      "types": "./fez.d.ts",
      "import": "./dist/fez.esm.js",
      "require": "./dist/fez.cjs",
      "default": "./dist/fez.esm.js"
    },
    "./plugin": "./src/fez/plugin.js",
    "./package.json": "./package.json"
  },
  "bin": {
    "fez": "bin/fez"
  },
  "engines": {
    "bun": ">=1.3.8"
  },
  "files": [
    ".version",
    "bin",
    "dist",
    "src",
    "fez.d.ts",
    "AGENTS.md",
    "README.md",
    "LICENSE"
  ],
  "keywords": [
    "dom",
    "elements",
    "custom-elements",
    "web-components",
    "frontend"
  ],
  "author": "Dino Reic",
  "license": "SEE LICENSE IN LICENSE",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/dux/fez.git"
  },
  "bugs": {
    "url": "https://github.com/dux/fez/issues"
  },
  "homepage": "https://github.com/dux/fez#readme",
  "devDependencies": {
    "esbuild": "0.23.0",
    "eslint": "^8.57.0",
    "glob-cli": "^1.0.0",
    "happy-dom": "^18.0.1",
    "jsdom": "^26.1.0"
  },
  "scripts": {
    "build": "bun build.js b",
    "deploy": "bun bin/deploy",
    "dev": "bun lib/dev.js",
    "lint": "eslint \"src/**/*.js\"",
    "format": "prettier --write \"src/**/*.js\"",
    "format:check": "prettier --check \"src/**/*.js\"",
    "test": "bun test test/*.test.js && bun test/browser/run.js",
    "test:browser": "bun test/browser/run.js",
    "prepublishOnly": "bun run build && bun run test",
    "release": "bun publish --access public",
    "static": "bun lib/site.js",
    "vscode:lint": "node --check vscode/src/extension.js",
    "vscode:package": "cd vscode && bunx @vscode/vsce package --allow-missing-repository --no-dependencies --out fez-vscode-tools.vsix",
    "vscode:install": "bun run vscode:package && code --install-extension vscode/fez-vscode-tools.vsix"
  },
  "dependencies": {
    "glob": "^13.0.0",
    "playwright": "^1.57.0",
    "prettier": "^3.8.1"
  },
  "peerDependencies": {
    "esbuild": ">=0.18"
  },
  "peerDependenciesMeta": {
    "esbuild": {
      "optional": true
    }
  }
}
